/* Privacy-mode feed. Deliberately a small, self-contained sheet rather than a
 * shared one with SidePanelNotificationList: the two components render
 * different trees, and importing the 300-line list stylesheet for four rules
 * would re-couple exactly what the split separated. The duplicated rules below
 * are the container/scroller/empty-state shell — if the app frame's scroll
 * behaviour changes, both sheets need the change. */

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scrollArea {
  flex: 1;
  /* min-height: 0 lets this flex child shrink below its content so overflow-y scrolls (Safari's implicit min-height: auto otherwise breaks the scroll). */
  min-height: 0;
  overflow-y: auto;
  /* Trap overscroll here: without this, hitting the top/bottom edge chains the
   * scroll out to the visual viewport, which rubber-bands the whole page —
   * shifting the pinned header/footer and exposing the browser's white canvas
   * behind the app (jarring in dark theme). `contain` keeps the bounce inside
   * this element so the app frame stays put. */
  overscroll-behavior: contain;
}

/* Never rename this to `.list` or fold it into a shared list class:
 * SidePanelNotificationList's `.list > li` rule forces each `<li>` into a
 * centered flex COLUMN, and a `PrivacyAppCard` lays its icon + text out in a
 * ROW. Sharing the class would silently restack every card — and jsdom cannot
 * see it, so no test would catch the regression. */
.privacyList {
  list-style: none;
  margin: 0;
  /* Top padding stands in for the search/actions rows that the normal list has
   * and this one doesn't — without it the first card hugs the header divider. */
  padding: var(--spacing-12) var(--spacing-16);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 48px var(--spacing-16);
  text-align: center;
  animation: fadeIn 0.3s ease-out;
}

.emptyIcon {
  color: var(--text-tertiary);
  margin-bottom: var(--spacing-12);
}

.emptyTitle {
  margin: 0 0 6px;
  font: var(--text-body-medium);
  color: var(--text-tertiary);
}

.emptyDescription {
  margin: 0;
  font-size: 13px;
  color: var(--text-tertiary);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
